import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=c5eeb9da&scoped=true"
import script from "./InfoItem.vue?vue&type=script&lang=js"
export * from "./InfoItem.vue?vue&type=script&lang=js"
import style0 from "./InfoItem.vue?vue&type=style&index=0&id=c5eeb9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eeb9da",
  null
  
)

export default component.exports